var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 -489.811L-489.811 256L-116.906 628.906L628.906 -116.906L256 -489.811Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M628.906 -116.906L-116.906 628.905L256 1001.81L1001.81 256L628.906 -116.906Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M513.573 -86.4267L-86.4265 513.573L-1.5737 598.426L598.426 -1.57394L513.573 -86.4267Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M525.948 -74.0517L-74.052 525.948L-13.9479 586.052L586.052 -13.9477L525.948 -74.0517Z",
    fill: "#E32D3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.629 72.3154L134.064 100.565L157.225 81.3172L152.136 110.999L181.818 105.911L162.57 129.072L190.82 139.506L162.57 149.94L181.818 173.101L152.136 168.012L157.225 197.694L134.064 178.446L123.629 206.696L113.195 178.446L90.0343 197.694L95.123 168.012L65.441 173.101L84.689 149.94L56.4392 139.506L84.689 129.072L65.441 105.911L95.123 110.999L90.0343 81.3172L113.195 100.565L123.629 72.3154Z",
    fill: "#FFD664"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.629 176.461C144.039 176.461 160.584 159.916 160.584 139.506C160.584 119.097 144.039 102.552 123.629 102.552C103.22 102.552 86.6748 119.097 86.6748 139.506C86.6748 159.916 103.22 176.461 123.629 176.461Z",
    fill: "#FFD664",
    stroke: "#2B4896",
    strokeWidth: 11.3362
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/NA.51ef92b543673970fecb09eafa1514a0.svg";
export { ForwardRef as ReactComponent };